import { MAX_LINE_TEXT_CHARS } from "../content/line.ts";

/**
 * Talking's bounds and words (ADR-136 decision 5, PROTOCOL.md 6.84.0): the `talk` verb an `interact` carries to an NPC,
 * the codes its refused `interaction` carries, and the three text messages of a conversation, `dialogue`,
 * `dialogueChoose` and `dialogueClose`, whose field tables are in `text.ts`.
 */

/**
 * The verb E sends to an NPC (ADR-136 decision 5.1).
 */
export const TALK_VERB = "talk";

/**
 * Why a `talk` is refused, carried as the text of its `interaction` with `ok` false, a code the page words from the
 * language files: the player is in combat (ruling 5: "They eye your blade and wait."), or the NPC is.
 */
export const TALK_REFUSALS = Object.freeze(["combat", "busy"] as const);

/**
 * One refusal code.
 */
export type TalkRefusal = (typeof TALK_REFUSALS)[number];

/**
 * Why a conversation closed (ADR-136 decision 5.5): the player ended it or chose an ending (`done`), walked 3 or more
 * tiles away (`walked`), entered combat (`combat`), the world swapped (`swap`), the NPC died, fought or left (`gone`),
 * or the server would not go on (`refused`).
 */
export const DIALOGUE_CLOSE_REASONS = Object.freeze(["done", "walked", "combat", "swap", "gone", "refused"] as const);

/**
 * One close reason.
 */
export type DialogueCloseReason = (typeof DIALOGUE_CLOSE_REASONS)[number];

/**
 * The longest text a `dialogue` carries, a line or a choice, in UTF-16 units: a line record's 300 code points, each at
 * most two units. The server sends only texts its dialogue validator held to 300 code points.
 */
export const MAX_DIALOGUE_TEXT_UNITS = 2 * MAX_LINE_TEXT_CHARS;
